import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './tourPriceCard.scss';
import { validateForm, validation } from '../../../utils/validation';
import { numberWithCommas } from '../../../utils/consts';
import {
  Input,
  RangeSlider,
  ValidationMessage,
  Dropdown,
  Button,
} from '../../../component';
const TourPriceCard = ({
  rooms = [],
  value = [],
  hotelName = {},
  onClick = () => {},
  moneyUnitList = [],
  language = { name: 'en', direction: 'ltr' },
  intl = {},
  initialAgeRange = {},
}) => {
  const [roomType, setRoomType] = useState('');
  const [roomsList, setRoomsList] = useState([]);
  const [ageRange, setAgeRange] = useState({ min: 0, max: 120 });
  const [price, setPrice] = useState([]);
  const [errors, setErrors] = useState({ roomType: [] });

  useEffect(() => {
    setAgeRange(initialAgeRange);
  }, [initialAgeRange]);
  useEffect(() => {
    let keysObject = {};
    moneyUnitList?.map(
      ({ moneyUnit }) => (keysObject = { ...keysObject, [moneyUnit]: [] }),
    );
    const currencyArray = initializePrices();
    setPrice(currencyArray);
    setErrors((prevError) => {
      return { ...prevError, ...keysObject };
    });
  }, [moneyUnitList]);
  useEffect(() => {
    setRoomsList(rooms);
  }, [rooms]);
  useEffect(() => {
    const index = value?.findIndex((data) => data?.roomType === roomType);
    if (index !== -1) {
      const editedValue = value[index]?.price.map((item) => {
        return { ...item, amount: numberWithCommas(item?.amount) };
      });
      setPrice(editedValue);
    } else {
      setPrice(initializePrices());
    }
  }, [roomType]);
  useEffect(() => {
    setRoomType('');
  }, [hotelName]);

  const handleValidation = () => {
    const pricingData = generatePricingObject();
    const hasTotalAmount = pricingData?.price?.reduce(
      (sum, { amount }) => sum + amount,
      0,
    );
    const { error, result } = validateForm({
      roomType: validation?.required(pricingData?.roomType)?.errors,
      price: validation?.number(hasTotalAmount)?.required()?.errors,
    });
    return { error, result };
  };
  const resetFields = () => {
    const currencyArray = initializePrices();
    setRoomType('');
    setPrice(currencyArray);
  };
  const handleAmountOnChange = (event, code) => {
    const amount = event?.target?.value?.replaceAll(',', '');
    const updatedPrices = price?.map((item) => {
      if (item?.currency?.moneyUnit === code) {
        return {
          ...item,
          amount: numberWithCommas(amount),
        };
      } else return item;
    });
    setPrice(updatedPrices);
    setErrors((errors) => {
      return {
        ...errors,
        [code]: validation?.number(amount)?.optional()?.errors,
      };
    });
  };
  const handleOnClick = () => {
    if (handleValidation()?.result) {
      const roomPriceObject = generatePricingObject();
      const index = value?.findIndex(
        ({ roomType }) => roomType === roomPriceObject?.roomType,
      );
      let updatePricingArray = value;
      if (index !== -1) {
        updatePricingArray[index] = roomPriceObject;
      } else {
        updatePricingArray?.push(roomPriceObject);
      }
      onClick(updatePricingArray);
      resetFields();
    }
  };
  const initializePrices = () => {
    const currencyArray = moneyUnitList?.map((currency) => {
      return {
        currency,
        amount: 0,
      };
    });
    return currencyArray;
  };
  const generatePricingObject = () => {
    const updatedPrice = price?.map((item) => {
      return {
        ...item,
        amount: +`${item?.amount}`.replaceAll(',', ''),
      };
    });
    return {
      roomType,
      passengerAgeRange: ageRange,
      price: updatedPrice,
    };
  };
  return (
    <div className="tour-price-card w-100 d-flex flex-wrap box-border default-border-radius-small p-3">
      <span className="w-100 d-flex border-bottom py-2 px-3 mx-3">
        {intl.formatMessage({ id: 'tour.pricepercustomer' })} /{' '}
        {hotelName?.[language?.name]
          ? hotelName?.[language?.name]
          : hotelName?.fa}
      </span>
      <span className="col-sm-6 col-12 mt-3 d-flex flex-column">
        <Dropdown
          direction="rtl"
          name="roomType"
          id="roomType"
          label="booking.roomtype"
          classNames="bg-third-light"
          outSideLabel={true}
          value={roomType}
          options={{
            isMultiLanguage: true,
            data: roomsList,
            label: 'name',
            value: 'name',
          }}
          customeStyle={{
            directtion: 'rtl',
          }}
          onChange={({ currentTarget }) => {
            const {
              valueObject: { name },
            } = currentTarget;
            setRoomType(name);
            setErrors((errors) => {
              return {
                ...errors,
                roomType: validation?.required(name)?.errors,
              };
            });
          }}
        />
        <ValidationMessage errors={errors?.roomType} />
      </span>
      {price?.map(({ currency, amount }) => {
        const { moneyUnit } = currency;
        return (
          <span
            key={moneyUnit}
            className="col-sm-6 col-12 mt-3 d-flex flex-column align-items-center justify-content-center"
          >
            <Input
              name={`${moneyUnit}`}
              label={moneyUnit}
              value={`${amount}`}
              onChange={(event) => handleAmountOnChange(event, moneyUnit)}
              iconUrl={null}
              outSideLabelClass="text-start"
              outSideLabelPosition="top"
              outSideLabel={true}
              themeMode="light"
            />
            <ValidationMessage errors={errors?.[moneyUnit]} />
          </span>
        );
      })}
      {Object.entries(ageRange).length &&
        ageRange?.max.toString() &&
        ageRange?.min.toString() && (
          <span className="col-sm-6 col-12 mt-3 d-flex">
            <RangeSlider
              max={initialAgeRange?.max}
              min={initialAgeRange?.min}
              title={intl.formatMessage({ id: 'tour.agerange' })}
              prefix={intl.formatMessage({ id: 'booking.year' })}
              minValue={ageRange?.min}
              maxValue={ageRange?.max}
              onChange={({ minVal, maxVal }) =>
                setAgeRange({ min: minVal, max: maxVal })
              }
            />
          </span>
        )}
      <span className="col-sm-6 col-12 mt-5 mt-sm-3 d-flex">
        <Button
          name={`approve-${hotelName}`}
          id={`approve-${hotelName}`}
          className="btn-secondary"
          width="w-100 px-0 py-4"
          type="submit"
          disabled={!handleValidation()?.result}
          label={intl.formatMessage({
            id: 'profile.approve',
          })}
          onClick={handleOnClick}
        />
      </span>
    </div>
  );
};

TourPriceCard.propTypes = {
  rooms: PropTypes.array,
  value: PropTypes.array,
  hotelName: PropTypes.object,
  onClick: PropTypes.func,
  moneyUnitList: PropTypes?.array,
  intl: PropTypes.object,
  language: PropTypes.object,
  initialAgeRange: PropTypes.object,
};

export default TourPriceCard;
